import React from "react";
import { Toolbar, useTheme, Tooltip, IconButton } from "@mui/material";
import OpenInFullOutlined from "@mui/icons-material/OpenInFullOutlined";
import { useNavigate } from "react-router-dom";

import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import CopilotChat from "./CopilotChat";

const openedMixin = (theme, drawerWidth) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: 0,
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, drawerwidth }) => ({
  width: drawerwidth,
  flexShrink: 0,
  whiteSpace: "pre-wrap",
  ...(open && {
    ...openedMixin(theme, drawerwidth),
    "& .MuiDrawer-paper": openedMixin(theme, drawerwidth),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Copilot = ({
  drawerWidth,
  isCopilotOpen,
  setIsCopilotOpen,
  isNonMobile,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleOpenFullPage = () => {
    navigate("/copilot/chat");
  };

  return (
    <Drawer
      open={isCopilotOpen}
      onClose={() => setIsCopilotOpen(false)}
      variant="permanent"
      anchor="right"
      drawerwidth={`${drawerWidth}%`}
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          borderWidth: isNonMobile ? 1 : "2px",
          borderColor: theme.palette.divider,
          backgroundColor: theme.palette.background.default,
          whiteSpace: "pre-wrap",
        },
      }}
    >
      <Toolbar />
      <CopilotChat
        historyVariant="overlay"
        headerActions={
          <Tooltip title="Open full page">
            <IconButton
              size="small"
              aria-label="Open Copilot in full page"
              onClick={handleOpenFullPage}
              sx={{ color: theme.palette.primary.main }}
            >
              <OpenInFullOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        }
      />
    </Drawer>
  );
};

export default Copilot;
